module.exports = __webpack_public_path__ + "static/presentations_sprite-b5e724d848b6e24302450c7212caf048.png";